
export const scrollTop = (store) => {
  return store.globalEvent.scrollTop;
};

// user
export const userInfo = (store) => {
  return store.user.userInfo;
};

// game
export const playerData = (store) => {
  return store.game?.playerData;
};

export const combatData = (store) => {
  return store.game?.combatData;
};
